// ===========================================
// ConfirmationModal.js
// 童顏家行程日曆系統 - 確認對話框元件
//
// 版本：V1.01 | 2024-07-05 20:00:00
// 主要功能：顯示確認對話框，支援自訂標題、訊息與按鈕
// 解決問題：統一彈窗確認操作，提升用戶體驗與一致性
//
// 版本紀錄：
// - V1.01 (2024-07-05): 初始版本，從 App.js 拆分
//
// 注意事項：
// - 支援 React 元素或字串訊息
// - 關聯檔案：App.js
// ===========================================
import React from 'react';

const ConfirmationModal = ({ config, onClose }) => {
    const { isOpen, title, message, onConfirm, customButtons } = config || {};
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center p-4 z-[60]">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md p-6" onClick={e => e.stopPropagation()}>
                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">{title}</h3>
                <div className="mb-6">
                    {typeof message === 'string' ? (
                        <p className="text-gray-600 text-center">{message}</p>
                    ) : (
                        message
                    )}
                </div>
                {customButtons ? (
                    <div className="flex flex-col gap-3">
                        {customButtons.map((button, index) => (
                            <button
                                key={index}
                                onClick={() => {
                                    if (button.onClick) button.onClick();
                                    onClose();
                                }}
                                className={`w-full py-3 px-4 rounded-lg font-bold transition-colors ${
                                    button.isDanger
                                        ? 'bg-red-600 hover:bg-red-700 text-white'
                                        : 'bg-gray-200 hover:bg-gray-300 text-gray-800'
                                }`}
                                autoFocus={button.autoFocus}
                            >
                                {button.label}
                            </button>
                        ))}
                    </div>
                ) : (
                    <div className="flex justify-center gap-4">
                        <button
                            onClick={onClose}
                            className="bg-gray-200 text-gray-800 font-bold py-2 px-6 rounded-lg hover:bg-gray-300"
                        >
                            取消
                        </button>
                        <button
                            onClick={() => {
                                if (onConfirm) onConfirm();
                                onClose();
                            }}
                            className="bg-red-600 text-white font-bold py-2 px-6 rounded-lg hover:bg-red-700"
                        >
                            確定
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ConfirmationModal; 